
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { PaySummaryHeader } from './header';
import { PaySummaryNav } from './nav';
import { PaySummaryRow } from './row';


export const PaySummaryTable = ({ title, id, invoiceLines }) => {


    const [linesToDisplay, setLinesToDisplay] = useState([]);
    const [collapse, setCollapse] = useState(true);
    const [filters, setFilters] = useState({
        order: {
            column: "number",
            asc: true
        },

    });

    const invoiceSum = useMemo(() => invoiceLines.reduce((acc, line) => { acc += line.totalPrice; return acc; }, 0), [invoiceLines]);
    const options = { style: 'currency', currency: 'EUR' };
    useEffect(() => {


        let temp = invoiceLines.filter(i => i.totalPrice !== 0);

        if (filters.order.asc) {

            temp = R.sort(R.ascend(R.prop(filters.order.column)), temp);

        } else {

            temp = R.sort(R.descend(R.prop(filters.order.column)), temp);

        }

        setLinesToDisplay(temp);


    }, [filters, invoiceLines]);




    return (
        <section className="block mb-4">
            <PaySummaryHeader title={title} id={id} collapse={collapse} setCollapse={setCollapse} />
            <article className="block">
                <PaySummaryNav id={id} collapse={collapse} filters={filters} setFilters={setFilters} />
                {
                    linesToDisplay.map((line, i) => (<PaySummaryRow key={line.product + i} quantity={line.quantity} currentPrice={line.currentPrice} totalPrice={line.totalPrice} product={line.product} />))
                }
            </article>
            <hr className="mb-2" />
            <div className="flex-row justify-content-between align-items-center">
                <h3 className="fs-3 font-weight-bold my-auto">Total</h3>
                <h4 className="h5 my-auto">{new Intl.NumberFormat('fr-FR', options).format(invoiceSum)}</h4>
            </div>
        </section>
    );
};